import { FC, memo } from 'react'

interface PasswordVisibleIconProps {
  visible: boolean
}

const PasswordVisibleIcon: FC<PasswordVisibleIconProps> = ({ visible }) =>
  visible ? (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.75 10.7998C13.9855 10.7998 15.7002 12.5145 15.7002 14.75C15.7002 16.9855 13.9855 18.7002 11.75 18.7002C9.51454 18.7002 7.7998 16.9855 7.7998 14.75C7.7998 12.5145 9.51454 10.7998 11.75 10.7998ZM11.75 12.4502C10.4855 12.4502 9.4502 13.4855 9.4502 14.75C9.4502 16.0145 10.4855 17.0498 11.75 17.0498C13.0145 17.0498 14.0498 16.0145 14.0498 14.75C14.0498 13.4855 13.0145 12.4502 11.75 12.4502ZM11.75 5.7998C16.7355 5.7998 20.7002 9.76454 20.7002 14.75V14.9502H19.0498V14.75C19.0498 10.7355 15.7645 7.4502 11.75 7.4502C7.73546 7.4502 4.4502 10.7355 4.4502 14.75V14.9502H2.7998V14.75C2.7998 9.76454 6.76454 5.7998 11.75 5.7998Z"
        fill="#86868B"
        stroke="#86868B"
        stroke-width="0.4"
      />
    </svg>
  ) : (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1174 8.375C19.1174 11.7812 15.8959 14.5425 11.922 14.5425C7.94806 14.5425 4.72656 11.7812 4.72656 8.375"
        stroke="#86868B"
        stroke-width="2.05583"
      />
      <path d="M18.1279 11.4531L20.5 13.8252" stroke="#86868B" stroke-width="2.05583" />
      <path d="M14.809 14.2969L15.7578 17.6178" stroke="#86868B" stroke-width="2.05583" />
      <path d="M5.87211 11.4531L3.5 13.8252" stroke="#86868B" stroke-width="2.05583" />
      <path d="M9.19103 14.2969L8.24219 17.6178" stroke="#86868B" stroke-width="2.05583" />
    </svg>
  )

export default memo(PasswordVisibleIcon)
